let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gvXdM")).then(() => parcelRequire('3p7ZR'));